module.exports = __webpack_public_path__ + "img/news-image-review5.70c971ed.png";